<template>
	<FormGroupBox
		:icon="tripIcon"
		:title="`${$t('bookings.service')} #${model.serviceNumber}`"
		:class="{rideSelected:isRideSelected}"
	>
		<template v-if="model.supplierConfirmation  != 'pending' && operatedBy == 'sc' " #append-title>
			<b-badge :variant="supplierConfirmationStatus.class">
				{{supplierConfirmationStatus.text}}
			</b-badge>
		</template>

		
		<b-form-row>
			<b-col class="col-lg-6 col-12">
				<b-form-row v-if="operatedBy == 'sc' && model.supplierConfirmation == 'pending' && model.status != 'partialCancellation'" class="m-0 p-0">
					<b-dropdown
						:text="$t('bookings.acceptReject') "
						size="md"
						v-show="!isMobile"
						variant="outline-primary"
						class="m-2"
					>
						<b-dropdown-item @click="saveSupplierConfirmation('confirmed')">
							<md-icon class="text-success" :icon="'task_alt'"> </md-icon>
							{{$t('bookings.acceptService')}}
						</b-dropdown-item>

						<b-dropdown-divider></b-dropdown-divider>

						<b-dropdown-item @click="saveSupplierConfirmation('rejected')" v-if="model.status=== 'active'">
							<md-icon class="text-danger" :icon="'clear'"> </md-icon>{{$t('bookings.rejectService')}}
						</b-dropdown-item>
					</b-dropdown>
					<!-- <b-button @click="() => saveSupplierConfirmed(false)" size="sm" variant="warning" class="ml-2" v-else><md-icon icon="error_outline"/> {{$t('bookings.rejectService')}}</b-button> -->
				</b-form-row>
			</b-col>
			<b-col class="col-lg-6 col-12">
				<b-form-row class="justify-content-end">
					<!-- Boton de cambios -->
					<b-button 
						class="pulsing-Button"
						size="sm"
						variant="primary"
						v-if="operatedBy == 'sc' && showTimeLineLogs == true"
						v-b-tooltip.hover
						:title="$t('timeline.historyChanges')"
						v-b-toggle.sidebar-timeline>
						<md-icon icon="circle_notifications"></md-icon>
					</b-button>
					<!-- End boton de cambios -->

					<b-form-group class="" :label="$t('bookings.status')"  label-cols-lg="12" label-cols="6">
						<b-form-select
							v-if="isNew"
							size="sm"
							v-model="model.status"
							:options="transportStatusOpts"
						/>
						<h4 v-else>
							<b-badge :variant="statusVariant" size="md">
								{{ statusLabel }}
							</b-badge>
							<b-button
								@click="showStatusEvidenceModal = true"
								v-if="
									model.status === 'noShow' || model.status === 'done'
								"
								size="sm"
								variant="warning"
								class="mx-1"
								><md-icon icon="visibility"
							/></b-button>
							<b-button
								v-if="operatedBy == 'supplier'"
								@click="showTrackingForm"
								size="sm"
								v-b-tooltip.hover
								title="Tracking"
								variant="success"
								>
								<md-icon icon="emoji_transportation"></md-icon>
							</b-button>
						</h4>
					</b-form-group>
				</b-form-row>
			</b-col>
		</b-form-row>

		
		<b-form-row
			v-if="domainPointOfsale !== false"
			class="justify-content-end"
		>
			<b-badge variant="primary"
				>{{ $t("global.pos") }} {{ domainPointOfsale }}</b-badge
			>
		</b-form-row>
		

		<div class="text-center" v-show="isMobile" v-if="operatedBy == 'sc' && model.supplierConfirmation == 'pending' && model.status != 'partialCancellation'">
			<b-dropdown
				:text="$t('bookings.acceptReject') "
				v-show="isMobile"
				variant="outline-primary"
				class="m-2"
				menu-class="w-100"
				block
			>
				<b-dropdown-item @click="saveSupplierConfirmation('confirmed')">
					<md-icon class="text-success" :icon="'task_alt'"> </md-icon>
					{{$t('bookings.acceptService')}}
				</b-dropdown-item>

				<b-dropdown-divider></b-dropdown-divider>

				<b-dropdown-item @click="saveSupplierConfirmation('rejected')" v-if="model.status=== 'active'">
					<md-icon class="text-danger" :icon="'clear'"> </md-icon>{{$t('bookings.rejectService')}}
				</b-dropdown-item>
			</b-dropdown>
		</div>
		
		<FormGroupBox :icon="'domain_add'" :title="`${$t('bookings.salesChannel')} & ${$t('serviceType.serviceType')}`" :class="{rideSelected:isRideSelected}" class="box-section sale-channel-section">
			<b-form-row>
				<b-form-group :class="{ 'col-lg-4': !isMobile, 'col-12': isMobile }" :label="$t('bookings.salesChannel')" size="sm" v-if="operatedBy == 'supplier'">
					<multiselect
						:taggable="false"
						v-model="saleChannelForSelect"
						:options="salesChannelOpts"
						:multiple="false"
						label="text"
						track-by="value"
						placeholder="Todos"
						:show-labels="false"
					/>
				</b-form-group>
				<!----<b-form-group
				v-if="operatedBy == 'supplier'"
				:class="{ 'col-4': !isMobile, 'col-12': isMobile }"
				:label="$t('bookings.salesChannel')"
				>
					<b-form-input
						:disabled="unableEdit"
						type="text"
						v-model="model.supplierSalesChannel"
					/>
				</b-form-group>----->
				<b-form-group
					v-if="model.salesChannel && operatedBy == 'sc'"
					class="col-12 col-lg-4"
					:label="$t('bookings.salesChannel')"
				>
					<b-form-input
						:disabled="unableEdit"
						type="text"
						v-model="model.salesChannel.name"
					/>
				</b-form-group>
				<b-form-group
					class="col-12 col-lg-4"
					:label="$t('bookings.salesChannelReference')"
				>
					<b-form-input
						:disabled="unableEdit"
						type="text"
						v-model="model.salesChannelReference"
						size="sm"
					/>
				</b-form-group>
	
				<b-form-group class="col-12 col-lg-4" :label="$t('bookings.serviceType')">
					<b-form-select
						v-if="operatedBy=='supplier'"
						:disabled="unableEdit"
						v-model="model.serviceTypeId"
						:options="serviceTypesOpts"
						required
						size="sm"
					/>

					<b-form-input
						v-else
						disabled
						type="text"
						size="sm"
						:value="model.supplierServiceType.name"
					/>
				</b-form-group>
			</b-form-row>
			<b-form-row v-if="operatedBy == 'supplier'" >
				<!-- Price when service is operatedBy -->
				<b-form-group
					class="col-12 col-lg-4"
					v-if="$root.userCan('revenue')"
					>
						<template #label>{{ $t('bookings.price') }} </template>
						<b-input-group  size="sm" prepend="$">
							<b-form-input
								:disabled="unableEdit || !model.supplierPriceOverride "
								v-model="model.supplierPriceTotal"
								type="number"
								step="0.01"
							></b-form-input>
							<b-input-group-append>
								<b-form-select
									:disabled="unableEdit"
									size="sm"
									:options="optsCurrencies"
									class="h-auto"
									v-model="model.supplierCurrency"
								></b-form-select>
							</b-input-group-append>
							
						</b-input-group>
						<b-form-checkbox
							size="sm"
							v-model="model.supplierPriceOverride"
							:value="true"
							:unchecked-value="false"
						>
							{{ $t("bookings.rateOverride") }}
						</b-form-checkbox>
				</b-form-group>
				<!-- End price when service is operatedBy -->

				<!---------INTERNAL REFERENCE-------->
				<b-form-group :label="$t('bookings.internalReference')" class="col-6 col-md-4" size="sm">
					<b-form-input size="sm" v-model="model.internalReference"></b-form-input>
				</b-form-group>	
				<!---------INTERNAL REFERENCE-------->
				<b-form-group class="col-12 col-lg-4" :label="'Sale channel title:'" v-if="showSupplierSaleChannel">
					<b-badge variant="info">{{ model.supplierSalesChannel }}</b-badge>
				</b-form-group>
			</b-form-row>

		</FormGroupBox>	
		<b-form-row class="justify-content-between">
			<b-form-group :label="$t('bookings.origin')" style="width: 45%" :class="{'mt-2': isMobile, 'mb-2': isMobile }" class="col-12 col-lg-5">
				<b-input-group v-if="!pickupEdit" size="sm">
					<b-form-input
						type="text"
						size="sm"
						v-model="model.pickup.name"
						readonly
						required
					/>
					<template #prepend>
						<b-button
							v-if="pickupLocationUrl"
							:href="pickupLocationUrl"
							target="_blank"
							variant="success"
							size="sm"
						>
							<md-icon :icon="pickupTypeIcon" />
						</b-button>
						<b-input-group-text v-else
							><md-icon :icon="pickupTypeIcon"
						/></b-input-group-text>
					</template>
					<template v-if="!unableEdit" #append>
						<b-button variant="primary" @click="pickupEdit = true"
							><md-icon icon="edit"></md-icon
						></b-button>
					</template>
				</b-input-group>

				<vue-typeahead-bootstrap
					v-else
					showAllResults
					size="sm"
					:placeholder="$t('global.search')"
					v-model="pickupSearch"
					:serializer="place => place.name"
					:data="pickupData"
					@hit="selected => setPlace('pickup', selected)"
				>
					<template #suggestion="{ data, htmlText }">
						<span v-html="htmlText"></span><br /><small>{{
							data.address
						}}</small>
					</template>
					<template #prepend>
						<b-input-group-text
							><md-icon :icon="pickupTypeIcon"
						/></b-input-group-text>
					</template>
					<template #append>
						<b-button variant="primary" @click="pickupEdit = false">
							<b-spinner v-if="pickupLoading" small />
							<span v-else>X</span>
						</b-button>
					</template>
				</vue-typeahead-bootstrap>
			</b-form-group>

			<b-form-group class="text-center swapPlaces" :class="{ 'col-1': !isMobile, 'col-12': isMobile }">
				<template #label=""><span class="d-none d-md-block">.</span></template>
				<b-button
					v-if="!unableEdit"
					@click="swapPlaces"
					:size="isMobile ? 'md' : 'sm'"
					variant="info"
					><md-icon icon="swap_horiz"
				/></b-button>
			</b-form-group>

			<b-form-group
				:label="$t('bookings.destination')"
				style="width: 45%"
				:class="{ 'col-5': !isMobile, 'col-12': isMobile, 'mb-2': isMobile }"
				class="col-12 col-lg-5"
			>
				<b-input-group v-if="!dropoffEdit" size="sm">
					<b-form-input
						type="text"
						size="sm"
						v-model="model.dropoff.name"
						readonly
						required
					/>
					<template #prepend>
						<b-button
							v-if="dropoffLocationUrl"
							:href="dropoffLocationUrl"
							target="_blank"
							variant="success"
							size="sm"
						>
							<md-icon :icon="dropoffTypeIcon" />
						</b-button>
						<b-input-group-text v-else
							><md-icon :icon="dropoffTypeIcon"
						/></b-input-group-text>
					</template>
					<template #append>
						<b-button
							v-if="!unableEdit"
							variant="primary"
							@click="dropoffEdit = true"
							><md-icon icon="edit"></md-icon
						></b-button>
					</template>
				</b-input-group>

				<vue-typeahead-bootstrap
					v-else
					showAllResults
					size="sm"
					:placeholder="$t('global.search')"
					v-model="dropoffSearch"
					:serializer="place => place.name"
					:data="dropoffData"
					@hit="selected => setPlace('dropoff', selected)"
				>
					<template #suggestion="{ data, htmlText }">
						<span v-html="htmlText"></span><br /><small>{{
							data.address
						}}</small>
					</template>
					<template #prepend>
						<b-input-group-text
							><md-icon :icon="dropoffTypeIcon"
						/></b-input-group-text>
					</template>
					<template #append>
						<b-button
							variant="primary"
							@click="dropoffEdit = false"
						>
							<b-spinner v-if="dropoffLoading" small />
							<span v-else>X</span>
						</b-button>
					</template>
				</vue-typeahead-bootstrap>
			</b-form-group>

		</b-form-row>
		<template v-if="model.pickup.isAirport || model.dropoff.isAirport">
			<label class="col-form-label">
				{{ $t("bookings.dateTimeAndNumberOf") }}
				<strong v-if="model.pickup.isAirport">{{
					$t("bookings.arrivalFlight")
				}}</strong>
				<strong v-else>{{ $t("bookings.departureFlight") }}</strong>
			</label>
			<b-form-row class="mb-1">
				<b-col class="col-7 col-lg-5">
					<b-form-datepicker
						:locale="$root.store.state.currentUser.lang"
						:disabled="unableEdit"
						required
						size="sm"
						v-model="flightDateStr"
					/>
				</b-col>
				<b-col  class="col-5 col-lg-3">
					<md-icon class="d-none d-lg-inline mr-auto mr-lg-2" icon="access_time" />
					<vue-timepicker
						:disabled="unableEdit"
						required
						v-model="flightTimeStr"
						manual-input
						input-width="6em"
					></vue-timepicker>
				</b-col>
				<b-col class="col-12 col-lg-4 mt-2 mt-lg-auto">
					<b-input-group>
						<b-input-group-prepend v-if="flight.loading">
							<b-button>
								<b-spinner small />
							</b-button>
						</b-input-group-prepend>
						<b-input-group-prepend v-else>
							<b-button
								size="sm"
								variant="info"
								v-b-tooltip.hover
								:title="$t('bookings.clickFlightInfo')"
								v-if="isThereFlight"
								@click="openFlightData()"
							>
								<md-icon icon="info" />
							</b-button>
							<b-button
								size="sm"
								variant="danger"
								v-if="model.flightValidationStatus === 'none'"
								v-b-tooltip.hover
								:title="$t('bookings.flightNotValidate')"
								type="button"
							>
								<md-icon icon="info" />
							</b-button>
							<b-button
								size="sm"
								variant="success"
								v-else
								type="button"
								ref="tooltip-validation-status"
								v-b-tooltip.hover
								:title="
									'El vuelo ha sido validado por ' +
										model.flightValidationStatus
								"
							>
								<md-icon icon="check_circle" />
							</b-button>
						</b-input-group-prepend>

						<b-form-input
							:disabled="unableEdit"
							type="text"
							size="sm"
							v-model="model.flightNumber"
							required
						/>
						<b-input-group-append v-if="!unableEdit">
							<b-button @click="validateFlightData()" size="sm" variant="info">
								<b-spinner v-if="flight.loading" small />
								<span v-else>{{$t('bookings.validate')}}</span>
							</b-button>
						</b-input-group-append>
					</b-input-group>
				</b-col>
			</b-form-row>

			<b-form-row
				v-if="
					(flight.showUseFlightOption ||
						this.model.flightValidationStatus === 'user') &&
						!flight.loading
				"
			>
				<b-col lg="4" offset-lg="8" cols="12"  class="text-right">
					<b-form-checkbox
						value="user"
						unchecked-value="none"
						v-model="model.flightValidationStatus"
					>
						Validación manual del vuelo
					</b-form-checkbox>
				</b-col>
			</b-form-row>
		</template>
		<label class="col-form-label">
			{{ $t("bookings.pickupDatetime") }}
		</label>
		<b-form-row class="mb-1">
			<b-col  class="col-7 col-lg-5">
				<b-form-datepicker
					:locale="$root.store.state.currentUser.lang"
					:disabled="unableEdit"
					required
					size="sm"
					v-model="pickupDateStr"
				/>
			</b-col>
			<b-col class="col-5 col-lg-3">
				<md-icon icon="access_time" class="d-none d-lg-inline mr-auto mr-lg-2" />
				<vue-timepicker
					:disabled="unableEdit"
					required
					v-model="pickupTimeStr"
					manual-input
					input-width="6em"
					class="mr-2"
				></vue-timepicker>
				<br />
				<span
					:class="
						timeBetwenFlightAndPickupAbs > 500 ? 'text-danger' : ''
					"
					v-if="timeBetwenFlightAndPickup"
				>
					<strong>{{ timeBetwenFlightAndPickupAbs }}</strong>
					{{ $t("global.minutes") }}
					<strong>{{
						timeBetwenFlightAndPickup >= 0
							? $t("global.before")
							: $t("global.after")
					}}</strong>
					{{ $t("global.ofFlight") }}
				</span>
			</b-col>
		</b-form-row>
		<hr />
		
		<b-form-row>
			<b-form-group class="col-12" :label="$t('bookings.supplierNotes')">
				<b-textarea
					:disabled="unableEdit"
					size="sm"
					v-model="model.supplierNotes"
				/>
			</b-form-group>
		</b-form-row>

		<b-form-row v-if="operatedBy == 'supplier'">
			<b-form-group class="col-12" :label="$t('bookings.clientNote')">
				<b-textarea
					:disabled="unableEdit"
					size="sm"
					v-model="model.clientNote"
				/>
			</b-form-group>
		</b-form-row>


		<b-form-row v-if="model.driver" class="mt-2">
			<b-col class="text-right">
				<span> <i v-html="svgDriverIcon" class="svg-icon"></i> {{ model.driver.firstName }} {{ model.driver.lastName }}</span>
			</b-col>
		</b-form-row>
		
		<hr />

		<b-form-row>
			<b-button
				:block="isMobile"
				:size="isMobile ? '' : 'sm'"
				v-if="enableCopy"
				class="mr-auto"
				variant="dark"
				@click="emitClone"
				><md-icon icon="library_add" />
				{{ $t("global.copy") }}</b-button
			>

			<template v-if="model.status == 'active' || model.status == 'pending'">
				<template v-if="model.id > 0 && model.status != 'pending'">
					<b-button
						:size="isMobile ? '' : 'sm'"
						:block="isMobile"
						class="mr-1"
						@click="() => changeStatus('noShow')"
						:variant="
							$root.auxVars.transportServiceStatusClasses.noShow
						"
						><md-icon icon="perm_identityhelp_outline" />
						{{ $t("bookings.noShow") }}</b-button
					>
					<template v-if="!hasLimitedData">
						<b-button
							:size="isMobile ? '' : 'sm'"
							:block="isMobile"
							class="mr-1"
							@click="() => changeStatus('noProvided')"
							:variant="
								$root.auxVars.transportServiceStatusClasses
									.noProvided
							"
							><md-icon icon="directions_carhelp_outline" />
							{{ $t("bookings.noProvided") }}</b-button
						>
						<b-button
							:size="isMobile ? '' : 'sm'"
							:block="isMobile"
							class="mr-1"
							@click="() => changeStatus('canceled')"
							:variant="
								$root.auxVars.transportServiceStatusClasses
									.canceled
							"
							><md-icon icon="delete" />
							{{ $t("bookings.cancel") }}</b-button
						>
					</template>
					<b-button
						:size="isMobile ? '' : 'sm'"
						:block="isMobile"
						class="mr-1"
						@click="() => changeStatus('done')"
						:variant="
							$root.auxVars.transportServiceStatusClasses.done
						"
						><md-icon icon="done" />
						{{ $t("bookings.done") }}</b-button
					>
				</template>
				<b-button
					v-if="model.status == 'pending' && model.id > 0"
					:size="isMobile ? '' : 'sm'"
					:block="isMobile"
					class="mr-1"
					@click="() => changeStatus('active')"
					variant="success"
					><md-icon icon="done" />
					{{ $t("bookings.confirm") }}</b-button
				>
				<b-button
					v-if="model.id <= 0"
					:size="isMobile ? '' : 'sm'"
					variant="danger"
					:block="isMobile"
					@click="emitDelete"
					><md-icon icon="delete" />
					{{ $t("global.delete") }}</b-button
				>
			</template>

		</b-form-row>

		<b-modal hide-footer ref="modal-view" size="lg" title="Datos de vuelo">
			<TemplateFlightItem
				:flight-data="model.flightValidationData"
				:typeOfFlight="flightLabel"
				@updateDateTimeFlight=emitUpdateDateTimeFlight
				v-if="isThereFlight"
			></TemplateFlightItem>
		</b-modal>
		<b-modal
			hide-footer
			ref="tracking-module"
			size="xl"
			:title="$t('bookings.trackingService')"
		>
			<TrackingServiceForm :index="index" :ride="model" :reservation="reservation" />
		</b-modal>
		<SingleTransportServiceChangeStatus
			v-if="model.id > 0"
			:transport-service-id="model.id"
			:show.sync="showChangeStatusModal"
			:status="newStatus"
			@onUpdate="() => $emit('onUpdate')"
			:require-files="operatedBy === 'sc'"
		/>
		<SingleTransportServiceStatusEvidence
			v-if="model.id > 0"
			:transport-service-id="model.id"
			:show.sync="showStatusEvidenceModal"
			:status="model.status"
		/>

		<b-sidebar 
			v-if="model.id != -1"
			id="sidebar-timeline" 
			sidebar-class="sidebar-timeline" 
			:title="$t('timeline.historyChanges')" 
			bg-variant="white"
			shadow
			lazy>
			<TimeLine 
				:model="reservation" 
				:modelId="reservation.id" 
				:transportServiceId="model.id">
			</TimeLine>
        </b-sidebar>
	</FormGroupBox>
</template>

<script>
import FormGroupBox from "../../helpers/FormGroupBox";
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
import { debounce } from "debounce";
import VueTimepicker from "vue2-timepicker";
import TemplateFlightItem from "./FlightItem";
import SingleTransportServiceChangeStatus from "./SingleTransportServiceChangeStatus";
import SingleTransportServiceStatusEvidence from "./SingleTransportServiceStatusEvidence";
import TrackingServiceForm from './tracking/TrackingTransportServiceForm';
import Resize from "../../helpers/Resize.js";
import Multiselect from 'vue-multiselect'
import TimeLine from "./TimeLine.vue"

let iconDriver = '<svg height="25px" width="25px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 508 508" xml:space="preserve" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <circle style="fill:#324A5E;" cx="254" cy="254" r="254"></circle> <path style="fill:#2C9984;" d="M438,428.8c-45.6,48-110,78.4-181.6,79.2l0,0c-0.8,0-1.6,0-2.4,0c-72.4,0-138-30.4-184-79.2l0,0 c17.2-59.6,54.8-63.6,54.8-63.6c49.2-23.6,78.8-57.2,80.4-59.2h97.2c1.6,2,31.2,35.6,80.8,59.2C383.2,365.2,421.2,369.2,438,428.8z"></path> <path style="fill:#FFD05B;" d="M307.2,437.2v-126c-3.6-2.4-6.8-6-8.4-10c-1.2-2.4-2-5.2-2.4-8.4l-4-53.6h-76.8l-2.8,40.4l0,0 l-0.8,13.2c-0.4,8-5.2,14.8-11.6,18.8v125.2l53.6,60.4L307.2,437.2z"></path> <path style="fill:#F9B54C;" d="M298.8,301.2L298.8,301.2c-64.4,50.8-85.6-19.2-86-21.6l0,0l2.8-40.4h77.2l4,53.6 C296.8,296,297.2,298.8,298.8,301.2z"></path> <polygon style="fill:#E6E9EE;" points="312,432.4 312,338 196,338 196,432.4 254,500 "></polygon> <polygon style="fill:#F1543F;" points="264.8,355.2 270.4,338 237.6,338 243.2,355.2 "></polygon> <polygon style="fill:#FF7058;" points="291.2,450.8 264.8,355.2 243.2,355.2 216.8,450.8 254,494.8 "></polygon> <path style="fill:#4CDBC4;" d="M329.2,436l-14.4-33.2h39.6c-10-46-36.8-80-49.6-94.4c-1.2-1.6-2.4-2.4-2.4-2.8H300 c4,10.4,10.8,39.6-8.8,82c0,0-20.4,58.8-37.6,106.4C236.4,446.4,216,387.6,216,387.6c-19.6-42.4-12.4-71.6-8.8-82h-2.4 c-0.4,0.4-1.2,1.2-2.4,2.8c-12.4,14-39.2,48.4-49.6,94.4h39.6L178,436c25.2,13.6,67.2,66.4,71.6,72c1.2,0,2.4,0,4,0 c0.8,0,1.6,0,2.4,0l0,0c0.4,0,0.8,0,1.2,0C262.4,502,304,449.6,329.2,436z"></path> <path style="fill:#2B3B4E;" d="M334.8,200.8c2.8-8.4,4.4-17.2,4.4-26.4c0-46.4-38.4-84-85.2-84c-47.2,0-85.2,37.6-85.2,84 c0,9.2,1.6,18,4.4,26.4H334.8z"></path> <path style="fill:#FFD05B;" d="M338.8,185.6c-3.2-1.6-7.2-0.8-10.8,2c-0.8-49.6-33.6-67.6-74-67.6s-73.2,18-73.6,67.6 c-4-2.8-7.6-3.6-10.8-2c-6.4,3.6-7.2,15.6-2,27.6c4.8,10.8,12.8,17.2,18.8,16c11.2,38.8,37.2,73.6,67.6,73.6s56.4-35.2,67.6-73.6 c6,1.2,14.4-5.2,18.8-16C346,201.2,344.8,188.8,338.8,185.6z"></path> <ellipse style="fill:#2B3B4E;" cx="254" cy="139.6" rx="70.4" ry="34.4"></ellipse> <path style="fill:#4CDBC4;" d="M176,119.2h156.4c15.6-6,27.6-14.4,32.4-24C378,68,330,40.8,254,40.8S130,68.4,143.6,95.2 C148.4,104.8,160.4,113.2,176,119.2z"></path> <g> <path style="fill:#2C9984;" d="M176,119.2c50-16.4,106.4-16.4,156.4,0c0,7.2,0,14.4,0,21.6c-52,0-104.4,0-156.4,0 C176,133.6,176,126.4,176,119.2z"></path> <circle style="fill:#2C9984;" cx="254" cy="77.6" r="17.6"></circle> </g> <g> <path style="fill:#FFFFFF;" d="M298.8,301.6c0,0-3.2,18-44.8,36.4c0,0,30.8,19.2,36.4,34.8C290.4,372.8,318.8,334,298.8,301.6z"></path> <path style="fill:#FFFFFF;" d="M209.6,301.6c0,0,3.2,18,44.4,36.4c0,0-30.8,19.2-36.4,34.8C217.6,372.8,189.2,334,209.6,301.6z"></path> </g> <path style="fill:#324A5E;" d="M254,250.4c-14-7.2-19.6,14.4-42,2c0,0,8.8,24.4,42,9.6c33.2,14.4,42-9.6,42-9.6 C273.6,264.8,268,243.2,254,250.4z"></path> </g></svg>'
export default {
	mixins: [Resize],
	props: {
		model: {
			type: Object,
			required: true
		},
		reservation: {
			type: Object,
			required: false
		},
		hasLimitedData: {
			type: Boolean,
			required: true
		},
		enableCopy: {
			type: Boolean,
			required: false,
			default: false
		},
		operatedBy: {
			type: String,
			required: true
		},
		enableAcceptService: {
			type: Boolean,
			required: false,
			default: true
		},
		index: Number,
	},
	components: {
		FormGroupBox,
		VueTypeaheadBootstrap,
		VueTimepicker,
		TemplateFlightItem,
		SingleTransportServiceChangeStatus,
		SingleTransportServiceStatusEvidence,
		TrackingServiceForm,
		Multiselect,
		TimeLine,
	},
	data() {
		return {
			newStatus: "active",
			showChangeStatusModal: false,
			showStatusEvidenceModal: false,
			showSupplierNotes: false,
			pickupEdit: false,
			dropoffEdit: false,
			pickupSearch: "",
			dropoffSearch: "",
			pickupLoading: false,
			dropoffLoading: false,
			pickupData: [],
			dropoffData: [],
			flight: {
				loading: false,
				showUseFlightOption: false,
				found: false
			},
			svgDriverIcon:iconDriver,
			showTimeLineLogs: false,
		};
	},
	computed: {
		statusLabel() {
			return this.$t(`bookings.serviceStatusOpts.${this.model.status}`);
		},
		statusVariant() {
			return this.$root.auxVars.transportServiceStatusOpts.find(
				status => status.value === this.model.status
			).class;
		},
		routeUrl() {
			let originQuery;
			if (this.model.pickup.latitude && this.model.pickup.longitude) {
				originQuery = `${this.model.pickup.latitude},${this.model.pickup.longitude}`;
			} else {
				originQuery = encodeURIComponent(this.model.pickup.name);
			}
			let destinationQuery;
			if (this.model.dropoff.latitude && this.model.dropoff.longitude) {
				destinationQuery = `${this.model.dropoff.latitude},${this.model.dropoff.longitude}`;
			} else {
				destinationQuery = encodeURIComponent(this.model.dropoff.name);
			}
			return `https://www.google.com/maps/dir/?api=1&origin=${originQuery}&destination=${destinationQuery}&travelmode=driving`;
		},
		pickupLocationUrl() {
			if (this.model.pickup.latitude && this.model.pickup.longitude) {
				return `https://www.google.com/maps/search/?api=1&query=${this.model.pickup.latitude},${this.model.pickup.longitude}`;
			} else {
				return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
					this.model.pickup.name
				)}`;
			}
		},
		dropoffLocationUrl() {
			if (this.model.dropoff.latitude && this.model.dropoff.longitude) {
				return `https://www.google.com/maps/search/?api=1&query=${this.model.dropoff.latitude},${this.model.dropoff.longitude}`;
			} else {
				return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
					this.model.dropoff.name
				)}`;
			}
		},
		flightDatetime() {
			return this.$moment(this.model.flightDatetime);
		},
		pickupDatetime() {
			return this.$moment(this.model.pickupDatetime);
		},
		requireFlightDatas() {
			return this.model.pickup.isAirport || this.model.dropoff.isAirport;
		},
		timeBetwenFlightAndPickupAbs() {
			return Math.abs(this.timeBetwenFlightAndPickup);
		},
		timeBetwenFlightAndPickup() {
			if (
				this.flightDatetime.isValid() &&
				this.pickupDatetime.isValid()
			) {
				return this.flightDatetime.diff(this.pickupDatetime, "minutes");
			}
			return false;
		},
		pickupTypeIcon() {
			let icon = "location_on";
			if (this.model.pickup.isAirport) icon = "flight";
			return icon;
		},
		dropoffTypeIcon() {
			let icon = "location_on";
			if (this.model.dropoff.isAirport) icon = "flight";
			return icon;
		},
		creationDatetimeStr() {
			return this.$moment(this.model.creationDatetime).format(
				"DD/MMMM/YYYY HH:mm:ss"
			);
		},
		unableEdit() {
			// return false
			return (
				this.hasLimitedData ||
				(this.model.status != "active" &&
					this.model.status != "pending")
			);
		},
		tripIcon() {
			if (this.model.pickup.isAirport) return "flight_land";
			//A2H
			else if (this.model.dropoff.isAirport) return "flight_takeoff";
			//H2A
			else return "place"; //P2P
		},
		flightLabel() {
			return this.model.pickup.isAirport ? "LLEGADA" : "SALIDA";
		},
		isNew() {
			return this.model.id == -1;
		},
		contactStatusOpts() {
			return this.$root.auxVars.transportServiceContactStatusOpts;
		},
		transportStatusOpts() {
			if (this.isNew) {
				const optios = [];
				const elm = this.$t("statusOptions");
				Object.keys(elm).forEach(item => {
					optios.push({ value: item, text: elm[item] });
				});
				return optios;
			} else {
				return this.$root.auxVars.transportServiceStatusOpts;
			}
		},
		serviceTypesOpts() {
			return this.$root.auxVars.serviceTypesOpts;
		},
		supplierOpts() {
			if (
				this.model.supplierId != -1 &&
				!this.$root.auxVars.suppliersOpts.find(
					st => st.value == this.model.supplierId
				)
			) {
				return [
					{
						value: this.model.supplier.id,
						text: this.model.supplier.name
					},
					...this.$root.auxVars.suppliersOpts
				];
			}
			return this.$root.auxVars.suppliersOpts;
		},
		pickupDateStr: {
			get: function() {
				let aux = this.$moment(this.model.pickupDatetime);
				return aux.isValid() ? aux.format("YYYY-MM-DD") : "";
			},
			set: function(v) {
				this.model.pickupDatetime = `${v} ${this.pickupTimeStr}`;
			}
		},
		pickupTimeStr: {
			get: function() {
				let aux = this.$moment(this.model.pickupDatetime);
				return aux.isValid() ? aux.format("HH:mm:00") : "00:00:00";
			},
			set: function(v) {
				this.model.pickupDatetime = `${this.pickupDateStr} ${v}`;
			}
		},
		flightDateStr: {
			get: function() {
				let aux = this.$moment(this.model.flightDatetime);
				return aux.isValid() ? aux.format("YYYY-MM-DD") : "";
			},
			set: function(v) {
				this.model.flightDatetime = `${v} ${this.flightTimeStr}`;
			}
		},
		flightTimeStr: {
			get: function() {
				let aux = this.$moment(this.model.flightDatetime);
				return aux.isValid() ? aux.format("HH:mm:00") : "00:00:00";
			},
			set: function(v) {
				this.model.flightDatetime = `${this.flightDateStr} ${v}`;
			}
		},
		domainPointOfsale() {
			return this.model.pointOfSale?.domain ?? false;
		},
		isThereFlight() {
			return (
				(this.model.flightValidationData?.number ?? "" !== "") &&
				this.model.flightValidationStatus === "api"
			);
		},
		supplierConfirmationStatus(){
			let text   = this.model.supplierConfirmation;
			let classe = "";
			switch(this.model.supplierConfirmation){
				case "rejected":
					text   = this.$t("bookings.notAccepted")
					classe = "danger"
					break;
				case "confirmed":
					text = this.$t("bookings.accepted")
					classe = "success"
					break;
			}
			return {text:text,class:classe};
		},
		isRideSelected(){
			return this.model.serviceNumber == this.$root.store.state.selectedServiceNumber && !this.$root.isEmpty(this.model.serviceNumber)
		},
		optsCurrencies() {
			return this.$root.auxVars.currencyOpts;
		},
		salesChannelOpts(){
			return this.$root.auxVars.salesChannelsOpts;
		},
		saleChannelForSelect: {
			get: function() {
				let val = this.salesChannelOpts.find(sc => {
					return (sc.value == this.model.salesChannelId )
				});
				return val;
			},
			set: function(value) {
				let newValue = -1;
				if(!this.$root.isEmpty(value)){
					newValue = value.value;
				}
				this.model.salesChannelId= newValue;
			}
		},
		showSupplierSaleChannel(){//this field was used to show the sale channel before integrate the saleChannelModel for transportist rides
			try{
				return (this.operatedBy =='supplier' && this.$root.isEmpty(this.saleChannelForSelect) && this.model.id>0 );
			}catch(err){
				console.log(err)
			}
			return false;
			
		},
	},
	methods: {
		emitUpdateDateTimeFlight(newDate, newTime){
			//cerramos el modal-dialogo
			this.$refs["modal-view"].hide();
			//actualizamos la fecha
			this.model.flightDatetime=newDate+" "+newTime;
			console.log(newDate+" "+newTime);
		},
		changeStatus(newStatus) {
			this.newStatus = newStatus;
			this.showChangeStatusModal = true;
		},
		swapPlaces() {
			let aux = this.model.pickup;
			this.model.pickup = this.model.dropoff;
			this.model.dropoff = aux;
			aux = this.model.pickupPlaceId;
			this.model.pickupPlaceId = this.model.dropoffPlaceId;
			this.model.dropoffPlaceId = aux;
		},
		emitDelete() {
			// this.
			this.$emit("delete");
		},
		emitClone() {
			this.$emit("clone");
		},
		setPlace(attrName, place) {
			this.model[`${attrName}PlaceId`] = place.id;
			this.model[attrName] = place;
			this[`${attrName}Edit`] = false;
		},
		searchPlace(attrName, term) {
			if (term != "") {
				this[`${attrName}Loading`] = true;
				this.$root.api
					.post(`/places/search`, { term })
					.then(res => {
						console.log(res.data)
						this[`${attrName}Data`] = res.data;
						this[`${attrName}Loading`] = false;
					})
					.catch(err => {
						console.log(err);
					});
			}
		},
		validateFlightData() {
			this.model.flightValidationStatus = "none";
			this.model.flightValidationData = {};
			this.flight.loading = true;
			this.flight.found = false;
			this.flight.showUseFlightOption = true;
			let params = {
				flightNumber: this.model.flightNumber,
				flightDate: this.flightDateStr,
				pickupRef: this.model.pickup.type + "-" + this.model.pickup.id,
				dropoffRef:
					this.model.dropoff.type + "-" + this.model.dropoff.id
			};
			this.$root.api
				.get("/flights/validate-flight", { params: params })
				.then(res => {
					if (res.data.valid) {
						this.flight.showUseFlightOption = false;
						this.flight.found = true;
						this.model.flightValidationStatus = "api";
						this.model.flightValidationData = res.data.flightData;
					} else {
						this.$root.showAlert("Numero de vuelo no es valido", {
							variant: "danger"
						});
					}
				})
				.finally(() => {
					this.flight.loading = false;
				});
		},
		openFlightData() {
			this.$refs["modal-view"].show();
		},
		hideFlightData() {
			this.$refs["modal-view"].hide();
		},

		saveSupplierConfirmation(option) {
			try {
				let msj = "";
				switch (option) {
					case "confirmed":
						msj = this.$t("bookings.confirmAcceptService");
						break;
					case "rejected":
						msj = this.$t("bookings.confirmRejectService");
						break;
					default:
						throw "Invalid option";
				}
				this.$bvModal
					.msgBoxConfirm(msj, {
						title: " ",
						size: "sm",
						buttonSize: "sm",
						okVariant: "success",
						okTitle: this.$t("global.yes"),
						cancelTitle: "No",
						footerClass: "p-2",
						hideHeaderClose: false,
						centered: true
					})
					.then(value => {
						if (value === true) {
							const query = {
								attrName: "supplierConfirmation",
								attrValue: option
							};
							this.$root.api
								.put(
									`/transport-services/${this.model.id}`,
									query
								)
								.then(() => {
									this.$root.showAlert(
										this.$t(
											`bookings.serviceUpdatedSuccessfully`
										)
									);
									this.$root.$emit("bv::refresh::table","reservations-index-list");
									this.$emit("onUpdate");
								})
								.catch(err => {
									this.$root.handleRequestError(err);
								})
								.finally(() => {
									//close();
								});
						}
					})
					.catch(err => {
						console.log(err);
						// An error occurred
					});
			} catch (err) {
				console.log(err);
			}
		},
		showTrackingForm() {
			this.$refs["tracking-module"].show()
		},
		verifyShowLogs() {
			if (this.operatedBy == 'sc') {
				this.showTimeLineLogs = false
				this.$root.api
				.get("history/timeline/show", { params: {
					filters: {transportServiceId: this.model.id}
				}})
				.then(res => {
					const data = res.data
					this.showTimeLineLogs = data.showTimeLine
				})
			}
		}
	},
	mounted() {
		this.$root.auxVars.loadResourcesOpts({vm: this, resourceNames: ['serviceTypesOpts','salesChannelsOpts']})
	},
	watch: {
		model: function() {
			this.verifyShowLogs();
		},
		flightDateStr: function(val) {
			if (this.pickupDateStr == "") this.pickupDateStr = val;
		},
		flightTimeStr: function(val) {
			if (this.pickupTimeStr == "") this.pickupTimeStr = val;
		},
		pickupSearch: debounce(function(term) {
			this.searchPlace("pickup", term);
		}, 500),
		dropoffSearch: debounce(function(term) {
			this.searchPlace("dropoff", term);
		}, 500)
	}
};
</script>

<style>
.vbst-item {
	line-height: normal;
}
.list-group-item {
	padding: 0.2rem 0.8rem;
}
.list-group {
	padding-top: 2px;
}
.vue__time-picker input.display-time {
	height: 1.95em;
}
input.display-time.all-selected.disabled {
	background-color: #e9ecef;
	color: #495057;
}

.pulsing-Button {
  box-shadow: 0 0 0 0 rgba(17, 150, 233, 0.7);
  -webkit-animation: pulsing 1.75s infinite cubic-bezier(0.66, 0, 0, 1);
  -moz-animation: pulsing 1.75s infinite cubic-bezier(0.66, 0, 0, 1);
  -ms-animation: pulsing 1.75s infinite cubic-bezier(0.66, 0, 0, 1);
  animation: pulsing 1.75s infinite cubic-bezier(0.66, 0, 0, 1);
  font-size: 16px;
  font-weight: normal;
  font-family: sans-serif;
  text-decoration: none !important;
  color: #ffffff;
  transition: all 300ms ease-in-out;
  width: 35px;
  height: 35px;
  padding: 6px;
  margin: 15px;
  border-radius: 50%;
}

/* Comment-out to have the button continue to pulse on mouseover */
a.pulsing-Button:hover {
  -webkit-animation: none;
  -moz-animation: none;
  -ms-animation: none;
  animation: none;
  color: #ffffff;
}

/* Animation */
@-webkit-keyframes pulsing {
  to {
    box-shadow: 0 0 0 30px rgba(232, 76, 61, 0);
  }
}

@-moz-keyframes pulsing {
  to {
    box-shadow: 0 0 0 30px rgba(232, 76, 61, 0);
  }
}

@-ms-keyframes pulsing {
  to {
    box-shadow: 0 0 0 30px rgba(232, 76, 61, 0);
  }
}

@keyframes pulsing {
  to {
    box-shadow: 0 0 0 30px rgba(232, 76, 61, 0);
  }
}

.sidebar-timeline{
	width: 41vw !important;
}

@media (max-width: 768px){
	.sidebar-timeline {
		width: 85vw !important;
	}
}

</style>
<style scoped>
.rideSelected{
	border: 3px solid green !important;
}
.box-section{
	border: unset !important;
	box-shadow:0px 0px 2px rgba(0, 0, 0, 0.5) !important;
	border-radius: 15px;
}
>>>.box-section h4{
	font-size: 1.2rem;
}
>>>.multiselect__tags{
	height: 33px !important;
	min-height: 33px !important;
	padding-top: 5px !important;
}
>>>.multiselect__select{
	top: -2px !important;
}

>>>.svg-icon{
	width: 30px;
	height: 30px;
}
</style>
